import { Card, Select } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { api } from '../../api/client';

interface Props {
  value: string[];
  onChange: (ids: string[]) => void;
}

/** 文章分類（多選）。 */
export default function CategoryCard({ value, onChange }: Props) {
  const categories = useQuery({ queryKey: ['categories'], queryFn: api.categories });
  return (
    <Card title="分類">
      <Select
        mode="multiple"
        className="w-full"
        placeholder="選擇分類"
        value={value}
        onChange={onChange}
        options={(categories.data ?? []).map((ct) => ({ value: ct.id, label: ct.name }))}
      />
    </Card>
  );
}
